export default __webpack_public_path__ + "static/media/Triangles-normal-map.d6d12f55.jpg";